var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg101(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg20",
    width: 1207,
    height: 503,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, "\n            .cls-4{fill:#262425}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    style: {
      stroke: "#f0f0f0",
      strokeWidth: 7,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(21.48 -4.955)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1",
    style: {
      stroke: "#f0f0f0",
      strokeWidth: 7,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g829",
    transform: "translate(-1225.98 8.545)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1.00018 0 -.09)",
    id: "g823"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1208 361.68h112.19V189.11c-15.18 19.83-40.92 29.09-71.27 29.09h-6.6V88.6h3.3c63.35 0 79.2-47.6 79.2-82h134v355.08h108.43v127.61H1208Z",
    id: "path12",
    style: {
      fill: "#f9f9f9",
      fillOpacity: 1,
      stroke: "#f9f9f9",
      strokeWidth: 7,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2048.78 361.68H2161V189.11c-15.18 19.83-40.92 29.09-71.27 29.09h-6.6V88.6h3.3c63.35 0 79.19-47.6 79.19-82h134v355.08H2408v127.61h-359.22z",
    id: "path14",
    style: {
      fill: "#f9f9f9",
      fillOpacity: 1,
      stroke: "#f9f9f9",
      strokeWidth: 7,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1630.47 326.64V169.27C1630.47 70.75 1701.09 0 1808.66 0c106.25 0 176.87 72.07 176.87 169.27v157.37c0 98.52-70.62 169.27-178.19 169.27-106.25 0-176.87-72.07-176.87-169.27z",
    id: "path16",
    style: {
      fill: "#f9f9f9",
      fillOpacity: 1,
      stroke: "#f9f9f9",
      strokeWidth: 7,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg101);
export default __webpack_public_path__ + "static/media/101.bb8589ff46cb38767f8a347c818bec42.svg";
export { ForwardRef as ReactComponent };